import {createSlice, current} from "@reduxjs/toolkit";
import {Feedback} from "../../models/Feedback";

/**
 * Feedback Slice
 * - Takes in feedback objects in db format
 * - Stores feedback objects in frontend format
 * - stores data as dict of dict:
 * data: { roomId1: [{Feedback Obj1}, {Feedback Obj2}, ...]
 *         roomId2: [ ... ],
 *         ...
 *       }
 * reference: { authorizedRoomId1: true,
 *              authorizedRoomId2: true,
 *              ...
 *            }
 */
const initialState = {
  loading: false,
  data: {},
  reference: {},
  error: "",
};

const feedbackSlice = createSlice({
  name: "feedback",
  initialState,

  reducers: {
    addFeedback: (state, action) => {
      let feedback = JSON.parse(JSON.stringify(new Feedback(action.payload)));

      if (!state.reference[feedback.roomId]) return;
      let displayDict = {...current(state.data)};

      if (feedback.roomId in displayDict) {
        displayDict[feedback.roomId] = [
          ...displayDict[feedback.roomId],
          feedback,
        ];
      } else {
        displayDict[feedback.roomId] = [feedback];
      }
      state.data = displayDict;
    },
    setFeedback: (state, action) => {
      let feedbackList = action.payload;
      let displayDict = {};
      for (let feedback of feedbackList) {
        feedback = JSON.parse(JSON.stringify(new Feedback(feedback)));
        if (feedback.roomId in displayDict) {
          displayDict[feedback.roomId].push(feedback);
        } else {
          displayDict[feedback.roomId] = [feedback];
        }
      }
      state.data = displayDict;
    },
    setFeedbackReference: (state, action) => {
      let roomList = action.payload;
      let copy = {};
      for (let room of roomList) {
        copy[room.room_id] = true;
      }
      state.reference = copy;
    },
  },
});

export const {setFeedback, addFeedback, setFeedbackReference} =
  feedbackSlice.actions;

export default feedbackSlice.reducer;
